import { StoreState } from "../../store/store.interface";

/*----- CREATE SELECTORS ------*/
export const getTax = (state: StoreState) => state.estimatedTaxState.data;

export const getEstimatedTaxStatus = (state: StoreState) => state.estimatedTaxState.status;

export const getZipCode = (state: StoreState) => state.estimatedTaxState.data?.zipCode;
